/* ============================================================
   PDP v2 content — sales-page copy per template framework:
   headline = outcome + timeframe + mechanism
   subheadline = "without ..." (acknowledge alternatives)
   bullets = benefit-driven; features live in education section
   NOTE FOR REVIEW: reviews are researcher-style placeholders
   written for structure — refine/replace before production.
   ============================================================ */
window.PDP_DATA = (() => {

  // ---- brand-wide (every product, RUO-compliant) ----
  const shared = {
    sub: 'Without grey-market mystery vials, overseas shipping roulette or purity claims you can’t verify.',
    bullets: [
      'HPLC + MS tested',
      'Per-batch COA',
      '≥99% purity',
      'Same-day dispatch',
    ],
    faqMini: [
      ['How do I verify the purity claim?', 'Every batch’s Certificate of Analysis is published on our COA page. Open the certificate for this product and read the HPLC purity result yourself — before or after you order.'],
      ['How fast is delivery?', 'Orders placed before 3pm dispatch the same day from our UK facility, fully tracked. No international shipping, no customs holds.'],
      ['What if something’s wrong with my order?', 'Damaged vial, wrong item, or a batch that doesn’t match its COA — we replace or refund it, no quibbles.'],
    ],
    faqFull: [
      ['Is this tested in-house or independently?', 'Independently. We pay an unaffiliated third-party UK laboratory to run HPLC and mass-spectrometry on every single batch. We publish their results, not our own.'],
      ['What does ≥99% purity actually mean?', 'The HPLC chromatogram shows the target peptide accounts for at least 99% of the material in the vial, with the remainder characterised. Batches below threshold are rejected and never listed.'],
      ['Why buy UK rather than import?', 'Imported peptides risk customs seizure, weeks in transit, and temperature abuse. UK stock dispatches same-day and arrives tracked within days.'],
      ['How should vials be stored?', 'Lyophilised peptides are stable short-term at room temperature. For research storage, keep sealed vials refrigerated (2–8°C) away from light; consult literature for reconstituted stability.'],
      ['Is this for human use?', 'No. Every product on this site is strictly For Research Use Only and is not for human or veterinary consumption. By ordering you confirm you are 18+ and purchasing for research purposes.'],
      ['Do you offer bulk or lab pricing?', 'The Buy 5 and Buy 10 tiers carry built-in volume discounts. For larger institutional quantities, contact us directly.'],
    ],
    steps: [
      ['Synthesised & sealed', 'Each batch is synthesised to specification, lyophilised and sealed under sterile conditions with a unique batch number.'],
      ['Independently tested', 'Samples go to an unaffiliated UK lab for HPLC purity analysis and mass-spec identity confirmation. Below 99%? The batch is destroyed, not discounted.'],
      ['COA published, then shipped', 'The full certificate goes live on our COA page before the batch is sold — the results are public before a single vial ships.'],
    ],
    compare: {
      cols: ['Peptides Direct', 'Grey-market imports'],
      rows: [
        ['Third-party COA for every batch', 'yes', 'no'],
        ['COA published before purchase', 'yes', 'no'],
        ['≥99% verified purity threshold', 'yes', 'unknown'],
        ['Same-day UK dispatch', 'yes', 'no'],
        ['No customs risk', 'yes', 'no'],
        ['UK-based support & guarantee', 'yes', 'no'],
      ],
    },
    guarantee: ['The Published COA Guarantee', 'If what arrives doesn’t match the certificate published for its batch, or your order turns up damaged or incorrect, we replace it or refund you in full. You take zero risk on quality.'],
    // researcher-style placeholder reviews — REFINE BEFORE PRODUCTION
    reviews: [
      ['Dr. E. Whitmore', 'Verified buyer', 'Checked the COA against the batch number before ordering — chromatogram was actually published, which almost nobody in this space does. Ordered Tuesday 2pm, arrived Wednesday.'],
      ['S. Okafor', 'Lab manager', 'We switched from a US supplier after two customs seizures. Same-day dispatch and the certificates are already online when the stock lists. Exactly what a supplier should be.'],
      ['M. Reid', 'Verified buyer', 'The purity documentation is the reason I buy here. Every batch I’ve ordered has had its full HPLC trace available — not a screenshot, the actual certificate.'],
      ['A. Fitzgerald', 'Research buyer', 'Third order. Consistent labelling, purity always lines up with the published COAs, and support replaced a cracked vial within 48 hours without asking for photos.'],
    ],
    ruoNote: 'For Research Use Only — Not for human or veterinary consumption. 18+.',
  };

  // ---- category mechanism blurbs (education "what it is") ----
  const categories = {
    'GLP / Metabolic': 'an incretin-pathway research peptide studied for activity at GLP-1 and related receptors in metabolic research models',
    'Recovery & Repair': 'a repair-pathway research peptide studied in tissue, tendon and gastric models',
    'Growth': 'a growth-axis research peptide studied for its interaction with GH secretion pathways in laboratory models',
    'Longevity': 'a longevity-research peptide studied in cellular ageing and mitochondrial models',
    'Cognitive': 'a cognitive-research peptide studied in neurological and neuroprotection models',
    'Aesthetics': 'a cosmetic-research peptide studied in dermal and melanogenesis models',
    'Essentials': 'a research-lab essential for peptide handling and reconstitution',
  };

  // ---- per-product headline overrides (outcome + timeframe + mechanism) ----
  // default headline is built from title in product.js
  const overrides = {
    'glp-3rt': { h1: 'Verified 99%+ Pure Retatrutide, At Your Door Tomorrow' },
    'bpc-157': { h1: 'Research-Grade BPC-157 You Can Verify Before You Buy' },
    'ghk-cu':  { h1: 'Lab-Verified GHK-Cu — Every Batch Proven, Published, Dispatched Same Day' },
    'mots-c':  { h1: 'MOTS-C With The Purity Receipts To Prove It' },
  };

  return { shared, categories, overrides };
})();
